var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminOdTopic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4a22d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139,134H123.25V22a3.73,3.73,0,0,0-3.73-3.74h-12v-13a3.73,3.73,0,0,0-3.73-3.73H39.24a3.73,3.73,0,0,0-3.73,3.73v13h-12A3.73,3.73,0,0,0,19.75,22V134H4a3.74,3.74,0,0,0,0,7.47H139a3.74,3.74,0,0,0,0-7.47ZM43,9h57v9.25H43ZM91.24,109v25h-16V109ZM67.77,134h-16V109h16Zm30.94,0v-28.7A3.73,3.73,0,0,0,95,101.55H48a3.73,3.73,0,0,0-3.73,3.73V134H27.22V25.74h88.56V134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.93,37.39H43.37a3.74,3.74,0,0,0,0,7.47H60.93a3.74,3.74,0,1,0,0-7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.93,74.9H43.37a3.73,3.73,0,0,0,0,7.46H60.93a3.73,3.73,0,1,0,0-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.93,56.14H43.37a3.74,3.74,0,0,0,0,7.47H60.93a3.74,3.74,0,1,0,0-7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.63,37.39H82.07a3.74,3.74,0,1,0,0,7.47H99.63a3.74,3.74,0,0,0,0-7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.63,74.9H82.07a3.73,3.73,0,1,0,0,7.46H99.63a3.73,3.73,0,1,0,0-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.63,56.14H82.07a3.74,3.74,0,1,0,0,7.47H99.63a3.74,3.74,0,0,0,0-7.47Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminOdTopic);
export default __webpack_public_path__ + "static/media/adminODTopic.4f3393ad.svg";
export { ForwardRef as ReactComponent };